import { handleActions } from "redux-actions";

import { setValidatorsObjectProperties } from "./actions";

const initialState = {
    isLoading: false,
    validators: {},
    ids: []
};

export const validatorsObjectPropertiesReducer = handleActions(
    {
        [setValidatorsObjectProperties]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);